import { render, staticRenderFns } from "./SettingsProfileDemographics.vue?vue&type=template&id=43f1089f&"
import script from "./SettingsProfileDemographics.vue?vue&type=script&lang=ts&"
export * from "./SettingsProfileDemographics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports